// Which bearer token, if any, a request to the Mashlom API carries.

// Requests that sign a user in, or run before anyone is signed in. They never
// carry a token, so a stale session left in the browser (e.g. a Microsoft
// account whose token can no longer be acquired) cannot block a password login.
const SIGN_IN_PATHS = [
  '/api/auth/login',
  '/api/auth/google',
  '/api/auth/capabilities',
];

export const isSignInRequest = (url = '') => {
  const path = String(url).split('?')[0];
  return SIGN_IN_PATHS.some(signInPath => path.endsWith(signInPath));
};

// Failing to get a token must not stop the request from being sent: it goes
// out without one and the server answers 401 if it needed a session.
export const tokenForRequest = async (url, getBearerToken) => {
  if (isSignInRequest(url)) return null;
  try {
    return await getBearerToken();
  } catch (error) {
    console.error('Could not get an access token; sending the request without one:', error?.errorCode || error?.name);
    return null;
  }
};
